export default __webpack_public_path__ + "static/media/pro_plan.1368c200.svg";